import React from "react";

const ShippingLabelProcedure=()=>{
    
    return(<div className="container p-3">
        <div className="container-3 p-4">
            <span style={{fontSize:20, fontWeight:500}}>Shipping label/QR code procedure:</span><br></br>
        <span style={{fontSize:15, fontWeight:400}}>To ensure the fastest possible processing and payment for your device, please review the checklist below before sending your device(s) to cash4device.ca.</span>
<br></br><br></br>
<span style={{fontSize:15, fontWeight:400}}><strong>You must: </strong>
Deactivate "find my" for apple devices

Turn Off Device Tracking (i.e. Find My iPhone, Samsung Reactivation Lock) and remove password, if any.
This can restrict the device to your account and prevent us from inspecting it. For Apple device, turn it off in the iCloud settings menu. For Samsung phones, check the Security settings.</span>
<br></br><br></br>
<span style={{fontSize:15, fontWeight:400}}><strong>We recommend: </strong>
  Save Your Data and/or back it up before resetting your devices to factory settings
If your device has an SD card or SIM card, remove it. We will remove all personal data from the device(s) upon receipt and will not be liable for any data loss.
<br></br><br></br>
Please do not send any extra items that you did not submit online. We cannot pay you for additional items or accessories.
Charge Your Device to minimize the processig time after we receive the device(s)
Devices received with at least a partial charge can be processed faster.</span>

<br></br><br></br>
<span style={{fontSize:15, fontWeight:400}}><strong>Please note :</strong> We do not accept devices that have been reported lost or stolen and iCloud or Activation locked.</span>
<br></br>
<span style={{fontSize:15, fontWeight:400}}>Offers are only valid through the expiration date listed in your email or 7 business day whichever comes first. Devices shipped after this date may receive a revised offer. We strongly recommend to create new order/trasaction if you passed shipping deadline to avoid any revised offer.</span>
<br></br>
<br></br>
<span style={{fontSize:15, fontWeight:400}}>1) Locate the QR code in your email inbox provided to the cash4device.ca website. Once you have located it, put your device(s) in sturdy box, which could fit your device(s), pack your device(s)  with appropriate packing cushionig materiales  inside the sturdy box and bring it to your local Canada Post drop-off location  for shipping.</span>
<br></br>
<br></br>
<span style={{fontSize:15, fontWeight:400}}>2) Bring the QR code to your local Canada Post drop-off location and get a mail box that will fit your items, if you not already heve packed your device(s).</span>
<br></br>
<br></br>
<span style={{fontSize:15, fontWeight:400}}>3)Be sure to pack it carefully and securely to avoid damage during the transit.</span>
        </div>
    </div>)
}
export default ShippingLabelProcedure;